import type { AssignmentResult } from './types';

/** Did this entry actually write anything — placement, status or dates? */
export function didChange(result: AssignmentResult): boolean {
  if (result.outcome === 'failed') return false;
  return (
    result.outcome !== 'unchanged' ||
    Boolean(result.activatedFrom) ||
    Boolean(result.startDate) ||
    Boolean(result.endDate)
  );
}
